import { render, staticRenderFns } from "./SelectSpaceGroupAndStatusModal.vue?vue&type=template&id=2cf906d4&"
import script from "./SelectSpaceGroupAndStatusModal.vue?vue&type=script&lang=js&"
export * from "./SelectSpaceGroupAndStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports